var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.5C0 8.73031 8.73031 0 19.5 0C30.2697 0 39 8.73031 39 19.5C39 30.2697 30.2697 39 19.5 39C8.73031 39 0 30.2697 0 19.5ZM19.9656 20.917C22.3819 21.5117 23.1059 22.2999 23.1059 23.6307C23.1059 25.0136 22.1756 26.0601 19.9656 26.2283V20.917ZM18.5055 17.9327C16.4385 17.4151 15.6626 16.5498 15.6626 15.3733C15.6626 14.1976 16.6449 13.1251 18.5063 12.8927L18.5055 17.9327ZM19.9656 18.2812V12.8927C21.6198 13.0991 22.7825 14.0424 22.9507 15.6715H25.6384C25.5352 12.7384 23.1961 10.7997 19.9656 10.5406V8.35738H18.5055V10.5406C15.249 10.7867 12.9236 12.6986 12.9236 15.5935C12.9236 18.2162 14.6941 19.6901 17.9757 20.4523L18.5055 20.5814V26.2153C16.4255 25.9959 15.4432 24.8844 15.2108 23.3724H12.5361C12.6254 26.4737 15.2238 28.3213 18.5055 28.5675V30.7377H19.9656V28.5675C23.2611 28.3343 25.8456 26.5387 25.8456 23.3724C25.8456 20.6204 23.985 19.2246 20.5863 18.4364L19.9656 18.2812Z",
    fill: "#437CF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.7d02e5d589081db1e7713077bb2cfb12.svg";
export { ForwardRef as ReactComponent };